@if(mode==="edit" || mode==="add"){

<div class="ppl-mt20">

  <form nz-form nz-row [formGroup]="identifierForm" class="ppl-p0">

    @if(isAttrAvailable('type')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="type">{{ getAttributes("type").label }}
          @if(getAttributes('type').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['type'] }">
              <ppl-dropdown-select formControlName="type" [disabled]="mode === 'edit'"
              id="type" [(ngModel)]="selectedIdentifierValue" (selectionChange)="onTypeChange($event)"
              [arialabel]="getAttributes('type').mandatory === 'Y' 
                ? getAttributes('type').label + ', required'  
                : getAttributes('type').label"
              [options]="identifiersList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['type'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['type'] ? 'type-error' : null">
              </ppl-dropdown-select>
          </div>
          @if (validationErrors['type']) {
          <span id="type-error" class="pl-1 error-message" role="alert">{{validationErrors['type']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>}

    @if(isAttrAvailable('value')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="value">{{getAttributes('value').label}}
          @if(getAttributes('value').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control pl-2">
          @if(selectedIdentifierValue === 'SSN'){
          <nz-input-group [nzSuffix]="suffixTemplate" style="height: 32px; padding: 0px 11px;"
            [ngClass]="{'error': validationErrors['value'] }">
            <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('value').tooltip}}" nzTooltipPlacement="topRight"
              [type]="ssnVisible ? 'text' : 'password'" formControlName="value" nzId="value"
              placeholder="{{getAttributes('value').placeholder}}" (input)="limitDigits($event)"
              [attr.aria-invalid]="validationErrors['value'] || ssnError || cinError ? 'true' : 'false'"
              [attr.aria-describedby]="
                (validationErrors['value'] ? 'value-error ' : '') +
                (ssnError ? 'ssn-error ' : '') +
                (cinError ? 'cin-error' : '')
              " />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <!-- We use eslint-disable here because the button's content is supplied by the nz-icon directive -->
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="ssnVisible ? 'Hide SSN' : 'Show SSN'" class="ssn-visible" nz-icon
              [nzType]="ssnVisible ? 'eye' : 'eye-invisible'" (click)="ssnVisible = !ssnVisible"></button>
          </ng-template>
          }@else{
          <input nz-input nz-tooltip [nzTooltipTitle]="getTooltipTitle()" nzTooltipPlacement="topRight"
            formControlName="value" id="value" placeholder="{{getAttributes('value').placeholder}}"
            [ngClass]="{'error': validationErrors['value'] }"
            [attr.aria-invalid]="validationErrors['value'] || ssnError || cinError ? 'true' : 'false'"
            [attr.aria-describedby]="
              (validationErrors['value'] ? 'value-error ' : '') +
              (ssnError ? 'ssn-error ' : '') +
              (cinError ? 'cin-error' : '')
            " />
          }
          @if (validationErrors['value']) {
          <span id="value-error" class="pl-1 error-message" role="alert">{{validationErrors['value']}}</span>
          }
          @if (ssnError) {
          <span id="ssn-error" class="pl-1 error-message" role="alert">Please enter a valid SSN</span>
          }
          @if (cinError) {
          <span id="cin-error" class="pl-1 error-message" role="alert">Please enter a valid CIN in the format XX00000X</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('startDate') && showStartDate()){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="startDate">{{getAttributes('startDate').label}}
          @if(getAttributes('startDate').mandatory === 'Y'){
          <span [attr.aria-label]="'Required'">*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['startDate'] }">
            <nz-date-picker formControlName="startDate" id="startDate" nzId="startDate" [nzFormat]="'MM/dd/yyyy'"
              [nzPlaceHolder]="getAttributes('startDate').placeholder"
              [attr.aria-invalid]="validationErrors['startDate'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['startDate'] ? 'startDate-error' : null"></nz-date-picker>
          </div>
          @if (validationErrors['startDate']) {
          <span id="startDate-error" class="pl-1 error-message" role="alert">{{validationErrors['startDate']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('preferred')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="preferred"
          class="ppl-form-label">{{getAttributes('preferred').label}}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-switch nzId="preferred" formControlName="preferred" pplNzAriaLabel nzAriaLabel="preferred"></nz-switch>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }


  </form>

</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>

  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()"></ppl-button>
</div>
}
@else if(mode === 'read'){
@if(leadStatus !== approvedStatus && !(entry === 'referral' && (leadStatus === 'Review Complete' || leadStatus === deniedStatus)) && !readOnly && !restrictReferralEdit){
<div class="custom-row">
  <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="doMfaAdd()"
    *authorize="[pageId, tabId, 'Identifiers', 'section', 'edit']"></ppl-button>

  <!-- <span nz-icon nzType="plus-circle" nzTheme="outline" (click)="add()"
        *authorize="[pageId, tabId, 'Identifiers', 'section', 'edit']"></span> -->
</div>
}

@if(copyOfGridData.length > 0){
@if(isMobileView){
<div class="card-layout pl-0 pr-0">
  <div class="card" *ngFor="let data of copyOfGridData">
    <div class="card-item mt-2">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Identifier Type: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.type}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Identifier Value: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.value}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    @if(data.startDate){
    <div class="card-item">
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Start Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.startDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    }
    <div>
      <nz-row>
        <div nz-col nzSpan="12" [nzXs]="24">
          <nz-row>
            <strong nz-col nzSpan="12" [nzXs]="12">Modified Date: </strong>
            <span nz-col nzSpan="12" [nzXs]="12">{{data.modifiedDate}}</span>
          </nz-row>
        </div>
      </nz-row>
    </div>
    @if(isSectionEditable && actionButtons && actionButtons.edit && actionButtons.delete) {
    <div class="btn-group mt-3 mb-2 d-flex justify-content-end">
      <div class="mr-2">
        <ppl-button ariaLabel="Edit" label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="action({data: data, action: 'edit'})"></ppl-button>
      </div>
      <ppl-button ariaLabel="Delete" label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
        [iconPosition]="'left'" (click)="action({data: data, action: 'delete'})"></ppl-button>
    </div>
    }
  </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>
}

}@else {
<nz-row>
  <p>No Data found</p>
</nz-row>
}

}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}

<div class="filter-panel">
  <ng-template #identifierHistoryDialog let-cancel="cancel">
    @if(historyData?.length > 0){
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable" [data]="historyTableData"
      [disableSelection]="true" [cols]="currentHistoryCols" [gridTitle]="false" [pagination]="true" [loadPage]="false"
      (gridAction)="action($event)">
  </ppl-list-table>
    }
    @else {
      No Data Available
    }
  </ng-template>

  <ng-template #blockConfirmDialog>
    <p>Blocking the SSN will disassociate the PA from all consumers. Are you sure?</p>
  </ng-template>
</div>